import { Box, Grid, Stack, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import { useNavigate } from 'router'
import { OPERATION_CREATE_PASSWORD } from '../operations-gql/mutations'
import { validationPassword } from './validation'
import LoginPassword from '../Login/components/LoginPassword'
import LoginButton from '../Login/components/LoginButton'
import LoginPaper from '../Login/components/LoginPaper'
import AuthBasePageWrapper from '../Login/AuthBasePageWrapper'

const NewSuccessPanel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <LoginPaper>
      <Stack gap={3} sx={{ alignItems: 'center', justifyContent: 'center' }}>
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '36px',
            fontWeight: 600,
            color: 'content.secondary'
          }}
        >
          {t('auth.confirmation.confirmed')}
        </Typography>
        <Box display="flex" width="100%">
          <LoginButton variant="contained" onClick={() => navigate({ pathname: '/auth/login' })}>
            {t('login.login_link')}
          </LoginButton>
        </Box>
      </Stack>
    </LoginPaper>
  )
}

const ConfirmationPanel = ({ token }) => {
  const { t } = useTranslation()
  const [createPassword, { data, loading }] = useMutation(OPERATION_CREATE_PASSWORD)

  const {
    handleSubmit,
    register,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationPassword(t)),
    defaultValues: {
      password: '',
      passwordConfirmation: ''
    }
  })

  const onSubmit = ({ password, passwordConfirmation }) => {
    createPassword({
      variables: {
        password,
        password_confirmation: passwordConfirmation,
        token
      }
    })
  }

  if (data?.recovery?.status) {
    return <NewSuccessPanel />
  }

  return (
    <LoginPaper>
      <Stack gap={3} sx={{ alignItems: 'center', justifyContent: 'center' }}>
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '36px',
            fontWeight: 600,
            color: 'content.secondary'
          }}
        >
          {t('auth.confirmation.title')}
        </Typography>
        <Grid container spacing={2} maxWidth={'400px'}>
          <Grid item xs={12}>
            <LoginPassword
              name="password"
              placeholder={t('login.new_password')}
              error={Boolean(errors.password)}
              errorMessage={errors.password?.message}
              InputProps={{
                ...register('password')
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <LoginPassword
              name="passwordConfirmation"
              placeholder={t('login.confirmation_password')}
              error={Boolean(errors.passwordConfirmation)}
              errorMessage={errors.passwordConfirmation?.message}
              InputProps={{
                ...register('passwordConfirmation')
              }}
            />
          </Grid>
        </Grid>

        <Box display="flex" width="100%">
          <LoginButton
            loading={loading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid}
          >
            {t('actions.create')}
          </LoginButton>
        </Box>
      </Stack>
    </LoginPaper>
  )
}

const Confirmation = () => {
  const { token } = useParams()

  return (
    <AuthBasePageWrapper>
      <ConfirmationPanel token={token} />
    </AuthBasePageWrapper>
  )
}

export default Confirmation
